<template>
    <v-flex class="white_background">
        <v-layout row wrap class="community-directory-page">
            <v-flex xs12 class="community-directory-page__title" data-qe-id="community-directory-page__title">
                {{communityDirectoryPageConstant.label.COMMUNITY_DIRECTORY_TITLE}}
            </v-flex>
            <community-directory></community-directory>
            <back-to-top></back-to-top>
        </v-layout>
    </v-flex>
</template>


<script>
    import CommunityDirectory from "./CommunityDirectory";
    import { communityDirectoryPageConstant } from "./communityDirectoryPage.constants";
    import BackToTop from '../Layout/BackToTop.vue';

    export default {
        name: 'CommunityDirectoryPage',
        components: {
            CommunityDirectory,
            BackToTop,
        },
        data() {
            return {
                communityDirectoryPageConstant,
            };
        },
    };
</script>

<style lang="scss" scoped>
    @import '../../common/styles/_colors.scss';
    @import '../../common/styles/_responsive.scss';

    .community-directory-page {
        position: relative;
        margin-top: 46px;
        padding: 0 80px;

        @include breakpoint(md) {
            padding: 0 45px;
        }

        @include breakpoint(xs) {
            padding: 0 5px;
        }

        &__title {
            background-color: $white;
            color: $ypo-blue;
            font-family: 'Raleway', sans-serif;
            padding: 35px 10px 0 0;
            font-size: 30px;
            font-weight: 500;
        }
        &__subtitle {
            font-weight: 500;
            font-size: 14px !important;
            color: $black;
            letter-spacing: 0.29px;
            line-height: 24px;
            padding: 0 15px 5px 0;
            margin-bottom: 10px;
        }
        @include breakpoint(xs) {
            margin-top: 55px;
            &__title {
                font-size: 18px;
                padding: 10px 15px 0 15px;
            }
            &__subtitle {
                padding: 5px 15px 5px 15px;
                line-height: normal;
            }
        }
    }
</style>
